<template>
	<div class="period-editor">
		<select v-model="month" class="month-select">
			<option v-for="(name, idx) in monthNames" :key="idx" :value="idx + 1">
				{{ name }}
			</option>
		</select>
		<input
			type="number"
			v-model="year"
			class="year-input"
			min="2000"
			max="2050"
			step="1"
		/>
	</div>
</template>
  
  <script>
export default {
	name: "PeriodCellEditor",
	data() {
		return {
			month: 1,
			year: new Date().getFullYear(),
			monthNames: [
				"Janvier",
				"Février",
				"Mars",
				"Avril",
				"Mai",
				"Juin",
				"Juillet",
				"Août",
				"Septembre",
				"Octobre",
				"Novembre",
				"Décembre",
			],
		};
	},
	created() {
		// Parse the initial value (if any)
		if (this.params && this.params.value) {
			try {
				const [month, year] = this.params.value.split("/");
				this.month = parseInt(month, 10);
				this.year = parseInt(year, 10);
			} catch (e) {
				console.error("Error parsing period value:", e);
			}
		}
	},
	methods: {
		// This is called by AG Grid when editing is complete
		getValue() {
			return `${this.padZero(this.month)}/${this.year}`;
		},

		// Helper function to format month with leading zero if needed
		padZero(num) {
			return num < 10 ? `0${num}` : `${num}`;
		},

		// These methods are required by AG Grid
		isPopup() {
			return true;
		},

		// Focus on the year input
		afterGuiAttached() {
			this.$el.querySelector(".year-input").focus();
		},
	},
};
</script>
  
  <style scoped>
.period-editor {
	display: flex;
	align-items: center;
	padding: 5px;
}

.month-select {
	flex: 1;
	margin-right: 5px;
	height: 30px;
	border: 1px solid #ccc;
	border-radius: 4px;
}

.year-input {
	width: 70px;
	height: 30px;
	border: 1px solid #ccc;
	border-radius: 4px;
	padding: 0 5px;
}
</style>